import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client/core';

const UPDATE_APPOINTMENT_REMINDER_LEAD_TIME_MUTATION = gql`
  mutation UpdateAppointmentReminderLeadTime(
    $appointmentReminderLeadTimeInMinutes: Int!
  ) {
    updateAppointmentReminderLeadTime(
      appointmentReminderLeadTimeInMinutes: $appointmentReminderLeadTimeInMinutes
    ) {
      success
      appointmentReminderLeadTimeInMinutes
    }
  }
`;

export const useUpdateAppointmentReminderLeadTime = () => {
  const [updateAppointmentReminderLeadTime, { loading, error, data }] =
    useMutation(UPDATE_APPOINTMENT_REMINDER_LEAD_TIME_MUTATION);

  const handleUpdateAppointmentReminderLeadTime = async (
    appointmentReminderLeadTimeInMinutes
  ) => {
    try {
      const result = await updateAppointmentReminderLeadTime({
        variables: { appointmentReminderLeadTimeInMinutes },
      });
      return result.data?.updateAppointmentReminderLeadTime;
    } catch (err) {
      console.error('Error updating appointment reminder lead time:', err);
      throw err;
    }
  };

  return { handleUpdateAppointmentReminderLeadTime, loading, error, data };
};
